import getNative from "./_getNative.js";
var nativeCreate = getNative(Object, "create");
export default nativeCreate;
